import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from "environments/environment";

@Injectable()
export class TelegramService {

  constructor(private readonly _httpClient: HttpClient) { }

  getMessage(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/telegram/message/${id}`);
  }

}
